module.exports = __webpack_public_path__ + "static/media/bathTap.ecc1065a.svg";